@if (paramMap$ | async; as paramMap) {
	@if (tabs$ | async; as tabs) {
		@if (entryPage$ | async; as entryPage) {
			<stages-card cardId="entryPagesCard">
				@if (tabs.length > 1) {
					<header class="contains-scrollable-tabs">
						<stages-tabs [activeTabName]="$any(getActiveTabName(tabs))">
							@for (tab of tabs; track tab) {
								<stages-tab-no-route [active]="active === tab.id" (activate)="tabClicked(tab)">
									<span tabTitle class="h5">{{ tab.name }}</span>
								</stages-tab-no-route>
							}
						</stages-tabs>
					</header>
				}
				<div class="panel">
					<stages-description
						[beanGuid]="entryPage.guid"
						[beanIdentity]="entryPage.id"
						[beanId]="entryPage.id"
						[beanType]="'entrypage'"
						[modifiable]="entryPage.actions.MODIFY"
						[unsafe]="false"
						[displayDescription]="entryPage.description"
						[descriptionService]="descriptionService"
						[workspaceId]="$any(paramMap.get('workspaceId'))"
						[pv]="$any(paramMap.get('processVersion'))"
						[properties]="{ linkOriginWorkspaceId: entryPage.rootWorkspaceId, imageContainerType: 'entrypage' }"
					>
					</stages-description>
				</div>
			</stages-card>
		}
	}
}
